import { SwiperCard } from "@datagame/ui";
import { motion } from "framer-motion";

import { Attribute } from "../../../../gql/graphql";
import { CARD_REVERT_DURATION } from "../../../../constants";
import { useGameVisuals } from "../../../../contexts/gameVisuals";
import brownCard from "../../../../assets/images/cards/brown.png";

import styles from "./Content.module.scss";

export enum CardState {
  Normal = "normal",
  Reversed = "reversed",
}

interface ContentProps {
  attribute: Attribute;
  isReversed?: boolean;
  initial?: CardState;
  children?: React.ReactNode;
}

const rotateDuration = CARD_REVERT_DURATION / 2;

export const Content = ({ attribute, initial = CardState.Reversed, isReversed = false, children }: ContentProps) => {
  const currentVariant = isReversed ? CardState.Reversed : CardState.Normal;
  const gameVisuals = useGameVisuals();

  const cardImageVariants = {
    [CardState.Reversed]: {
      rotateY: 0,
      transition: {
        duration: rotateDuration,
        delay: rotateDuration,
      },
    },
    [CardState.Normal]: {
      rotateY: -90,
      transition: {
        duration: rotateDuration,
        delay: CARD_REVERT_DURATION,
      },
    },
  };

  const cardContentVariants = {
    [CardState.Reversed]: {
      rotateY: 90,
      transition: {
        duration: rotateDuration,
      },
    },
    [CardState.Normal]: {
      rotateY: 0,
      transition: {
        duration: rotateDuration,
        delay: CARD_REVERT_DURATION + rotateDuration,
      },
    },
  };

  return (
    <>
      <motion.div
        className={styles.cardBackWrapper}
        variants={cardImageVariants}
        initial={initial}
        animate={currentVariant}
      >
        <img src={gameVisuals?.cardBackImage?.url ?? brownCard} className={styles.cardBack} alt="card back" />
      </motion.div>
      <motion.div
        className={styles.cardContent}
        variants={cardContentVariants}
        initial={initial}
        animate={currentVariant}
      >
        <SwiperCard
          name={attribute.name}
          customText={attribute.customText}
          showImageAndText={attribute.showImageAndText}
          imageUrl={attribute.image?.url}
        >
          {children}
        </SwiperCard>
      </motion.div>
    </>
  );
};
